/** Types of charts to show for a subject in dashboard page */
export enum SubjectCardTabType {
  Activity,
  Time,
  Progress,
}
